import API from "../axiosConfig";

export const   getHolidays = async () => {
  try {
    const response = await API.get("/holidays");
    return response.data;
  } catch (error) {
    console.error("Error fetching holidays:", error);
    throw error;
  }
};


export const createHoliday = async (lineData) => {
  try {
    const response = await API.post("/holidays", lineData);
    return response.data;
  } catch (error) {
    console.error("Error creating section:", error);
    throw error;
  }
};

export const updateHoliday = async (lineId, lineData) => {
  try {
    const response = await API.put(`/holidays/${lineId}`, lineData);
    return response.data;
  } catch (error) {
    console.error("Error updating section:", error);
    throw error;
  }
};